// Initial State
export const model = {
  data: null,
};

const userReducer = (state = model) => state;

export default userReducer;
